module.exports = __webpack_public_path__ + "static/img/100209.d4e5ee94.png";